import { z } from 'zod';

export const FIAT_CURRENCIES = ['USD', 'CAD'] as const;

export const FiatCurrencySchema = z.enum(FIAT_CURRENCIES);

export type FiatCurrency = z.infer<typeof FiatCurrencySchema>;
